// DO NOT EDIT THIS FILE MANUALLY,
// IT IS LOADED FROM THE NTR-CHAT-BACKEND CONFIG

export default {
	"timeline": {
		"words_per_minute": 210
	}
};